import React from "react";
import { observer } from "mobx-react";
import { WeaDatePicker } from "ecCom";

@observer
export default class YearPickerItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaDatePicker
        ecId={`${this.props.ecId}_WeaDatePicker@4451qh`}
        {...bindObj.bind()}
        format="YYYY"
        onChange={this.onChange}
        {...c}
        {...c.otherParams}
        formatPattern={c.formatPattern || 2}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/YearPickerItem.js